const getDrawioID = (src: string, articlePath: string) => `Drawio_${src}_${articlePath}`;

export default getDrawioID;
